<ng-container *ngIf="!(srvRpDesign.isMobile$ | async)">
  <div class="bg-white">
    <div class="px-0 px-sm-3 mx-3 my-5">
  
      <div class="font-dialog-tips-title d-flex justify-content-center" [ngStyle]="UIUtilityService.getHeaderStyle()">
        <span>{{ label | translate }}</span>
      </div>
  
      <div class="item-center m-5">
        <mat-icon svgIcon="falInfoCircle" class="icon-size-70 icon-center" [ngStyle]="UIUtilityService.getHeaderStyle()"></mat-icon>
      </div>
  
      <div class="mt-4 mx-1 font-dialog-tips-content" *ngFor="let message of tipsMessage; index as idx">
        <span [ngClass]="getClass(idx)">
          {{message | translate}}
        </span>
      </div>
    </div>
  </div>
</ng-container>
<ng-container *ngIf="(srvRpDesign.isMobile$ | async)">
  <div class="bg-white">
    <div class="px-0 mx-3 my-4">
  
      <div class="font-dialog-tips-title d-flex justify-content-center" [ngStyle]="UIUtilityService.getHeaderStyle()">
        <span>{{ label | translate }}</span>
      </div>
  
      <div class="item-center m-3">
        <mat-icon svgIcon="falInfoCircle" class="icon-size-60 icon-center" [ngStyle]="UIUtilityService.getHeaderStyle()"></mat-icon>
      </div>
  
      <div class="font-dialog-tips-content" *ngFor="let message of tipsMessage; index as idx">
        <span [ngClass]="getClass(idx)">
          {{message | translate}}
        </span>
      </div>
    </div>
  </div>
</ng-container>
